export const scrollToItem = (domItemId: string, pixelAdjustment = 0) => {
  document.documentElement.style.scrollBehavior = "smooth";

  const domItem = document.getElementById(domItemId);
  if (domItem) window.scrollTo(0, domItem.offsetTop - pixelAdjustment);

  document.documentElement.style.scrollBehavior = "unset";
};
